<template>      
	<form @submit.prevent="checkForm" class="mb-4">
		<div class="row">
			<div class="col-12" v-if="form_message !== ''">
				<ErrorAlert :messageI18n="form_message" />
			</div>
			

			<div class="col-12">
				<div class="form-group">
					<label for="checkdepositconfiguration_libelle">{{ $t('check.checkdepositconfiguration_libelle') }}</label>
					<input type="text" v-model="default_form.checkdepositconfiguration_libelle" class="form-control" id="checkdepositconfiguration_libelle">
				</div>
				<div class="form-group">
					<label for="checkdepositconfiguration_bank">{{ $t('check.checkdepositconfiguration_bank') }} *</label>
					<input type="text" v-model="default_form.checkdepositconfiguration_bank" class="form-control" id="checkdepositconfiguration_bank" :class="{ 'is-invalid': error && error.indexOf('Bank') > -1 }">
				</div>

				<div class="form-group">
					<label for="checkdepositconfiguration_accountnumber">{{ $t('check.checkdepositconfiguration_accountnumber') }} *</label>
					<input type="text" v-model="default_form.checkdepositconfiguration_accountnumber" class="form-control" id="checkdepositconfiguration_accountnumber" :class="{ 'is-invalid': error && error.indexOf('Number') > -1 }">
				</div>

				<div class="form-group">
					<label for="checkdepositconfiguration_bankaccountnumber">{{ $t('check.checkdepositconfiguration_bankaccountnumber') }} *</label>
					<input type="text" :disabled="payment_method_detailed" v-model="default_form.checkdepositconfiguration_bankaccountnumber" class="form-control" id="checkdepositconfiguration_bankaccountnumber" :class="{ 'is-invalid': error && error.indexOf('account') > -1 }">
				</div>

				<div class="form-group">
					<label for="checkdepositconfiguration_journal">{{ $t('check.checkdepositconfiguration_journal') }} *</label>
					<input type="text" :disabled="payment_method_detailed" v-model="default_form.checkdepositconfiguration_journal" class="form-control" id="checkdepositconfiguration_journal" :class="{ 'is-invalid': error && error.indexOf('code_journal') > -1 }">
				</div>

				<div class="form-group">
					<label for="checkdepositconfiguration_iban">{{ $t('check.checkdepositconfiguration_iban') }}</label>
					<input type="text" v-model="default_form.checkdepositconfiguration_iban" class="form-control" id="checkdepositconfiguration_iban" :class="{ 'is-invalid': error && error.indexOf('iban') > -1 }">
				</div>
				<div class="form-group">
					<label for="checkdepositconfiguration_bic">{{ $t('check.checkdepositconfiguration_bic') }}</label>
					<input type="text" v-model="default_form.checkdepositconfiguration_bic" class="form-control" id="checkdepositconfiguration_bic" :class="{ 'is-invalid': error && error.indexOf('iban') > -1 }">
				</div>

				<div class="form-group">
					<label for="checkdepositconfiguration_bankaddress">{{ $t('check.checkdepositconfiguration_bankaddress') }} *</label>
					<textarea v-model="default_form.checkdepositconfiguration_bankaddress" class="form-control" id="checkdepositconfiguration_bankaddress" :class="{ 'is-invalid': error && error.indexOf('address') > -1 }"></textarea>
				</div>

				<div class="form-group">
					<label for="checkdepositconfiguration_currency">{{ $t('check.checkdepositconfiguration_currency') }} *</label>
					<CurrencyInput id="checkdepositconfiguration_currency" v-model="default_form.checkdepositconfiguration_currency" />
				</div>

				<div class="form-group">
					<label for="checkdepositconfiguration_bridgeaccount">{{ $t('check.checkdepositconfiguration_bridgeaccount') }}</label>
						<e-select
                            v-model="bridge_account_selected"
                            id="bridgeaccount_id"
                            track-by="bridgeaccount_id"
                            label="bridgeaccount_name"
                            :placeholder="$t('check.selectionner_compte')"
                            :selectedLabel="$t('global.selected_label')"
                            :options="bridge_accounts"
                            :searchable="true"
                            :loading="loading_accounts"
                            :show-labels="false"
                            group-values="accounts"
                            group-label="bridgebank_name"
                            :group-select="false"
                            @select="setBridgeAccount"
                        >
                            <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                        </e-select>
				</div>
				<div class="form-group">
					<b-form-checkbox
						class="float-right mr-2"
						v-model="payment_method_detailed"
						name="payment_method_detailed" 
					>{{ $t('compta.choose_cdpaymentmethod') }}</b-form-checkbox>
				</div>
				<div class="form-group" v-if="payment_method_detailed">
					<div v-for="payment_method in payment_methods" :key="payment_method.paymentmethod_id" class="mb-2 mt-2">
						<hr>
						<h2>{{ $t('payment.payment_method_labels.' + payment_method.paymentmethod_code.toLowerCase())}}</h2>
						<div class="form-group">
							<label :for="'cdpaymentmethod_bankaccountnumber_' + payment_method.paymentmethod_id">{{ $t('check.checkdepositconfiguration_bankaccountnumber') }}</label>
							<input type="text" v-model="cd_paymentmethod[payment_method.paymentmethod_id].cdpaymentmethod_bankaccountnumber" class="form-control" :id="'cdpaymentmethod_bankaccountnumber_' + payment_method.paymentmethod_id" :class="{ 'is-invalid': error && error.indexOf('account') > -1 }">
						</div>
	
						<div class="form-group">
							<label :for="'cdpaymentmethod_journal_' + payment_method.paymentmethod_id">{{ $t('check.checkdepositconfiguration_journal') }}</label>
							<input type="text" v-model="cd_paymentmethod[payment_method.paymentmethod_id].cdpaymentmethod_journal" class="form-control" :id="'cdpaymentmethod_journal_' + payment_method.paymentmethod_id" :class="{ 'is-invalid': error && error.indexOf('code_journal') > -1 }">
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
</template>

<script type="text/javascript">
	import { EventBus } from 'EventBus'

    import Config from "@/mixins/Config.js"
	import TableAction from "@/mixins/TableAction.js"
	import Accounting from "@/mixins/Accounting.js"
	import Navigation from "@/mixins/Navigation.js"
	import OpenBank from "@/mixins/OpenBank.js"
	import _groupBy from 'lodash/groupBy'


	export default {
		name: "CheckDepositConfigurationAdd",
		mixins: [Config, TableAction, Accounting, Navigation, OpenBank],
		props: ['processing', 'ready', 'checkdepositconfiguration_id', 'checks_config', 'accountingplan_id'],
		data () {
			return {
				form_message: '',
				error: [],
				default_form: {
				    checkdepositconfiguration_id: null,
				    checkdepositconfiguration_bank: null,
				    checkdepositconfiguration_libelle: null,
				    checkdepositconfiguration_bankaccountnumber: null,
				    checkdepositconfiguration_journal: null,
				    checkdepositconfiguration_accountnumber: null,
				    checkdepositconfiguration_iban: null,
				    checkdepositconfiguration_bic: null,
				    checkdepositconfiguration_accountingplan: this.local_accountingplan_id,
					checkdepositconfiguration_bankaddress: null,
					checkdepositconfiguration_bridgeaccount: null,
					checkdepositconfiguration_currency: null
				},
				bridge_accounts: [],
				bridge_account_selected: null,
				loading_accounts: false,
				payment_method_detailed: false,
				payment_methods: null,
				cd_paymentmethod: []
			}
		},
		mounted() {
			this.init_component()
		},
		created () {
		},
		methods: {
			async init_component() {
				this.local_accountingplan_id = this.accountingplan_id ? this.accountingplan_id : this.$route.params.accountingplan_id
				if(this.checkdepositconfiguration_id != null){
					this.default_form = this.deppCloneObj(this.checks_config).filter(checks_config => checks_config.checkdepositconfiguration_id == this.checkdepositconfiguration_id)[0]
				}
				else {
					// Un nouveau compte est proposé dans la devise du tiers lié à la comptabilité
					const accounting_plan = await this.loadAccountingPlanFromLocal(this.local_accountingplan_id)
					this.default_form.checkdepositconfiguration_currency = accounting_plan.tiers.tiers_currency
				}

				this.loading_accounts = true
				const bridge_accounts = await this.getBridgeAccounts()

				const account_groupby = []
				for(let i in bridge_accounts) {
					let bank = account_groupby.findIndex(acc => acc.bridgebank_id == bridge_accounts[i].bridge_bank.bridgebank_id)
					if(bank == -1) {
						account_groupby.push({...bridge_accounts[i].bridge_bank, accounts: []})
						bank = account_groupby.findIndex(acc => acc.bridgebank_id == bridge_accounts[i].bridge_bank.bridgebank_id)
					}
					account_groupby[bank].accounts.push(bridge_accounts[i])
				}

				this.bridge_accounts = account_groupby
				this.loading_accounts = false

				if(this.default_form.checkdepositconfiguration_bridgeaccount) {
					this.bridge_account_selected = bridge_accounts.find(acc => acc.bridgeaccount_id == this.default_form.checkdepositconfiguration_bridgeaccount)
				}
				this.payment_methods = this.getConfig('payment_method')

				// Si il y a déjà des payment méthods détaillées
				this.payment_method_detailed = this.default_form.cd_paymentmethod && this.default_form.cd_paymentmethod.length > 0
				if(this.payment_method_detailed){
					this.default_form.cd_paymentmethod.forEach((pm) => {
						const cd = {
							cdpaymentmethod_paymentmethod: pm.cdpaymentmethod_paymentmethod,
							cdpaymentmethod_checkdepositconfiguration: pm.cdpaymentmethod_checkdepositconfiguration,
							cdpaymentmethod_journal: pm.cdpaymentmethod_journal,
							cdpaymentmethod_bankaccountnumber: pm.cdpaymentmethod_bankaccountnumber,
						}
						this.cd_paymentmethod[pm.cdpaymentmethod_paymentmethod] = cd
					})
				}
			},

			async checkForm(){

				this.$emit('update:processing', false)
				if(!this.processing)
				{
					// this.processing = true
					this.$emit('update:processing', true)
					this.error = []

					if(this.default_form.checkdepositconfiguration_bank === null || this.default_form.checkdepositconfiguration_bank == '')
					{
						this.error.push("Bank")
					}

					if(this.default_form.checkdepositconfiguration_accountnumber === null || this.default_form.checkdepositconfiguration_accountnumber == '')
					{
						this.error.push("Number")
					}

					if(this.default_form.checkdepositconfiguration_bankaccountnumber === null || this.default_form.checkdepositconfiguration_bankaccountnumber == '')
					{
						this.error.push("account")
					}

					if(this.default_form.checkdepositconfiguration_journal === null || this.default_form.checkdepositconfiguration_journal == '')
					{
						this.error.push("code_journal")
					}
					
					if(this.error.length == 0)
					{
						this.form_message = ""

						let result_check_config = null

						this.default_form.checkdepositconfiguration_accountingplan = this.local_accountingplan_id
						this.default_form.cd_paymentmethod = this.payment_method_detailed ? this.cd_paymentmethod : []
						result_check_config = await this.updateCreateCheckDepositConfig(this.default_form, this.default_form.checkdepositconfiguration_accountingplan);

						if(result_check_config)
						{
							this.$emit('update:processing', false)
							// this.processing = false
							return true
						}
						else
						{
							this.failureToast();
						}
					}
					else
					{
						this.form_message = "formulaire.erreur_champs_non_remplis"
						this.failureToast('formulaire.erreur_champs_non_remplis');
					}

					this.$emit('update:processing', false)
					// this.processing = false
					return false;
				}
			},
			setBridgeAccount(account) {
				this.default_form.checkdepositconfiguration_bridgeaccount = account.bridgeaccount_id
				this.default_form.checkdepositconfiguration_libelle = account.bridgeaccount_name
				this.default_form.checkdepositconfiguration_iban = account.bridgeaccount_iban
				this.default_form.checkdepositconfiguration_bank = account.bridge_bank.bridgebank_name
				this.default_form.checkdepositconfiguration_currency = account.bridgeaccount_currency
			}
		},
		computed: {
			
		},
		watch:{
			'payment_method_detailed' (val) {
				if(!val) {
					this.default_form.cd_paymentmethod = []
				} else if(!this.default_form.cd_paymentmethod || this.default_form.cd_paymentmethod.length == 0){
					this.payment_methods.forEach((pm) => {
						const cd = {
							cdpaymentmethod_paymentmethod: pm.paymentmethod_id,
							cdpaymentmethod_checkdepositconfiguration: this.default_form.checkdepositconfiguration_id,
							cdpaymentmethod_journal: this.default_form.checkdepositconfiguration_journal,
							cdpaymentmethod_bankaccountnumber: this.default_form.checkdepositconfiguration_bankaccountnumber,
						}
						this.cd_paymentmethod[pm.paymentmethod_id] = cd
					})
				}
			},
		},
		components: {
			CustomTable: () => import('GroomyRoot/components/Table/CustomTable') ,
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35') ,
			ErrorAlert: () => import('GroomyRoot/components/Alert/ErrorAlert'),
			CurrencyInput: () => import('GroomyRoot/components/Inputs/CurrencyInput'),
		}
	}
</script>